import React from 'react';
import '../Services.css';
import Image1 from '../../Gemco-Website-Images/Services/construction_pipe.jpg';

const Service_one = () => {
  return (
    <div className='wp_sub_service'>
      <div className="container wp_sub_service_container">
          <div className="row wp_service_row">
            <div className="content-column">
              <div className="inner-column wp_service_inner_column">
                <div className='sec-title forseotitle wp_service_sec_title'>
                  <h1>MEP Supply and Installation</h1>
                  <p>Gandhi Electro Mechanical Co. LLC delivers the complete spectrum of mechanical, electrical
                      and plumbing works — from full supply and installation on major new-build projects to
                      complex fit-out and specialist scopes. Trusted by the UAE's leading MEP contractors and
                      direct clients alike.</p>
                  {/* <ul>
                    <li className="service_list_item">Installation of chillers</li>
                    <li className="service_list_item">cooling towers</li>
                    <li className="service_list_item">pumps</li>
                    <li className="service_list_item">AHUs</li>
                    <li className="service_list_item">FCUs</li>
                    <li className="service_list_item">VRF and package units</li>
                    <li className="service_list_item">Cable containment</li>
                    <li className="service_list_item">cabling</li>
                    <li className="service_list_item">DB/SMDB/MDB feeders</li>
                    <li className="service_list_item">HVAC piping</li>
                    <li className="service_list_item">fittings</li>
                    <li className="service_list_item">valves</li>
                    <li className="service_list_item">supports and ducting</li>
                    <li className="service_list_item">Plumbing and drainage systems</li>
                    <li className="service_list_item">ELV and BMS containment and wiring</li>
                    <li className="service_list_item">Shutdowns</li>
                    <li className="service_list_item">tie-ins and system rerouting</li>
                    <li className="service_list_item">Testing</li>
                    <li className="service_list_item">commissioning and handover documentation</li>
                  </ul> */}
                </div>
              </div>
            </div>
            <div className="image-column">
              <img src={Image1} width="500" height="400" alt="" />
            </div>
          </div>
      </div>
    </div>
  )
}

export default Service_one